// app/constants/dockTabs.ts

export const DOCK_TABS = [
    { path: "/home", label: "Home", icon: "heroicons:home-20-solid" },
    {
        path: "/settings",
        label: "Settings",
        icon: "heroicons:cog-6-tooth-20-solid",
    },
] as const

export type DockTabPath = (typeof DOCK_TABS)[number]["path"]
